import { useState, useEffect } from 'react';
import debounce from '@services/debounce';
import { breakpointBoundary } from '@constants/layout/breakpoints';
import { useEventCallback } from '@hooks/use-event-callback';

const DEFAULT_DELAY = 100;

export const useLayoutBreakpoint = (delay) => {
  const [breakpoint, setBreakpoint] = useState();

  const getBreakPoint = () => {
    const size = window.innerWidth;

    if (size < breakpointBoundary.sm) {
      return 'xs';
    }

    if (size < breakpointBoundary.md) {
      return 'sm';
    }

    if (size < breakpointBoundary.lg) {
      return 'md';
    }

    if (size < breakpointBoundary.xl) {
      return 'lg';
    }

    return 'xl';
  };

  const handleDebouncedWindowResize = useEventCallback(
    debounce(() => {
      const newBreakPoint = getBreakPoint();
      if (newBreakPoint !== breakpoint) {
        setBreakpoint(newBreakPoint);
      }
    }, delay || DEFAULT_DELAY)
  );

  useEffect(() => {
    const initialBreakpoint = getBreakPoint();
    setBreakpoint(initialBreakpoint);

    window.addEventListener('resize', handleDebouncedWindowResize);

    return () => {
      window.removeEventListener('resize', handleDebouncedWindowResize);
    };
  }, []);

  return breakpoint;
};
